import React from "react";
import { Box, Typography } from "@mui/material";

const Badge = ({ label, textColor, bgColor }) => {
  return (
    <Box
      sx={{
        ...styles.container,
        backgroundColor: bgColor,
      }}
    >
      <Typography
        sx={{
          ...styles.text,
          color: textColor,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default React.memo(Badge);

const styles = {
  container: {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "6px",
    px: 1.5,
    py: 0.5,
  },
  text: { fontSize: "12px", fontWeight: 500 },
};
